import { Epic, ofType } from 'redux-observable';
import { EpicDependencies } from '@ui/store/rootEpic';
import * as actions from '../actions';
import { catchError, switchMap, map } from 'rxjs/operators';
import { of } from 'rxjs';
import { notification } from 'antd';

export const createCollection: Epic<any, any, any, EpicDependencies> = (
  action$,
  store,
  { collectionApi },
) =>
  action$.pipe(
    ofType(actions.CREATE_COLLECTION_ACTIONS.REQUESTED),
    switchMap(({ payload: { collection, file } }) =>
      collectionApi.createCollection(collection).pipe(
        switchMap(({ newCollection }) => {
          if (file) {
            return collectionApi
              .uploadPhoto(newCollection.id, file)
              .pipe(
                switchMap(newCollectionData =>
                  of(
                    actions.createCollectionSucceeded(newCollectionData),
                    actions.removeEditCollection(),
                  ),
                ),
              );
          }

          return of(
            actions.createCollectionSucceeded(newCollection),
            actions.removeEditCollection(),
          );
        }),
        catchError(error =>
          of(actions.createCollectionFailed(error)).pipe(
            map(response => {
              notification.error({
                message: response.error.response.message,
              });
              return response;
            }),
          ),
        ),
      ),
    ),
  );



// WEBPACK FOOTER //
// ./src/scenes/Collections/services/epics/createCollection.ts